/** 初回起動時の Loading 表示の上限時間 (ms) */
export const LoadingLimitMilliSecond = 2000;

/** メンテナンス表示 */
export const isMaintenance: boolean = false;
export const maintenanceStart: string | null = '2000-01-01T00:00:00+09:00';
export const maintenanceEnd: string | null = '2999-01-01T00:00:00+09:00';

/** インシデント表示 */
export const isIncident: boolean = false;
